import type { StreakLeg } from './types.ts';
/** Mechanical checks only: no claimed probability or moderator approval. */
export function reviewCombination(official:StreakLeg[],chosen:StreakLeg[],now=new Date()) {
 const issues:string[]=[];
 if(chosen.length<2||chosen.length>5)issues.push('Choose between 2 and 5 selections.');
 const odds=chosen.reduce((total,l)=>total*l.odds,1);
 if(chosen.some(l=>!Number.isFinite(l.odds)||l.odds<=1))issues.push('Some quoted odds are unavailable.');
 if(odds<4.5||odds>5.5)issues.push('Combined odds are outside the 4.50–5.50 target.');
 if(new Set(chosen.map(l=>l.fixture_id)).size!==chosen.length)issues.push('Multiple selections cover the same fixture.');
 if(chosen.some(l=>Date.parse(l.kickoff_at)<=now.getTime()))issues.push('Some fixtures have already kicked off; this combination is for review only.');
 if(chosen.filter(l=>['A-','B+'].includes(l.grade)).length>2)issues.push('More than two supporting selections are included.');
 const changed=chosen.length!==official.length||chosen.some(l=>!official.some(o=>o.id===l.id));
 return {odds,issues,changed,added_legs:Math.max(0,chosen.length-official.length)};
}
